import { connect } from 'react-redux';
import ReplyFeedback from 'Components/Feedback/ReplyFeedback';
import { FeedbackAction } from 'Actions'

function mapStatetoProps(state){
    const { formLoading, errorElement, error, feedbackDetails } = state.feedback
    return{
        formLoading,
        errorElement,
        error,
        feedbackDetails
    } 
}
const mapDispatchtoProps = {
    FeedbackDetails: FeedbackAction.FeedbackDetails
}

export default connect(mapStatetoProps,mapDispatchtoProps)(ReplyFeedback)